import React, { useContext } from "react";
import style from "./index.module.scss";
import { useHistory } from "react-router-dom";
import classNames from "classnames";
import { message } from "antd";
import ResourceModal from "../ResourceModal";
import SignInModal from "../SignInModal";
import {
    CourseContext,
    currentResourceAtom,
    resourceModalAtom
} from "../../../../Store";
import VoteModal from "../VoteModal";
import { useAtomValue, useSetAtom } from "jotai";

interface FooterProps {
    folded: boolean;
    toggleFolded: () => void;
}

export default function Footer({ folded, toggleFolded }: FooterProps) {
    const history = useHistory();
    const { basename } = useContext(CourseContext);

    const setResourceModalState = useSetAtom(resourceModalAtom);
    const currentResourceState = useAtomValue(currentResourceAtom);

    function isMatch(path: string) {
        return history.location.pathname.indexOf(path) !== -1;
    }

    function showTip() {
        message.info("该功能建设中, 敬请期待...");
    }

    // 点击课件按钮
    function onResourceClick() {
        if (currentResourceState?.id && !isMatch("resource"))
            return history.replace(
                `${basename}/resource?id=${currentResourceState?.id}`
            );
        setResourceModalState("resource");
    }

    // 点击签到按钮
    function onSignInClick() {
        // if (currentSignInId && !isMatch("sign")) return history.replace(`sign?id=${currentSignInId}`);
        setResourceModalState("signIn");
    }

    // 点击投票按钮
    function onVoteClick() {
        setResourceModalState("vote");
    }

    // 选人按钮
    function onRollCallClick() {
        history.replace(`${basename}/rollcall`);
    }

    return (
        <div className={classNames(style.root, { [style.folded]: folded })}>
            <div className={style.links}>
                <div
                    role="button"
                    onClick={onResourceClick}
                    className={classNames(style.course, {
                        [style.current]: isMatch("resource")
                    })}>
                    课件
                </div>
                <div
                    role="button"
                    onClick={onSignInClick}
                    className={classNames(style.sign, {
                        [style.current]: isMatch("sign")
                    })}>
                    签到
                </div>
                <div
                    role="button"
                    onClick={onRollCallClick}
                    className={classNames(style.rollcall, {
                        [style.current]: isMatch("rollcall")
                    })}>
                    选人
                </div>
                <div
                    role="button"
                    onClick={onVoteClick}
                    className={classNames(style.vote, {
                        [style.current]: isMatch("vote")
                    })}>
                    投票
                </div>
                <div
                    role="button"
                    onClick={showTip}
                    className={classNames(style.homework, {
                        [style.current]: isMatch("homework")
                    })}>
                    作业
                </div>
                <div
                    role="button"
                    className={style.fold}
                    onClick={toggleFolded}>
                    收起
                </div>
            </div>

            <ResourceModal />
            <SignInModal />
            <VoteModal />
        </div>
    );
}
